module.exports = __webpack_public_path__ + "img/r8.44093f79.jpg";